import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const Splash: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isLoading) {
        if (isAuthenticated) {
          navigate('/dashboard');
        } else {
          navigate('/register');
        }
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center animate-fadeIn">
        <div className="mb-8">
          <div className="text-6xl animate-pulse">💪</div>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-2 animate-slideUp">
          FitGenie
        </h1>
        <p className="text-lg text-gray-600 animate-slideUp" style={{ animationDelay: '100ms' }}>
          Your AI-Powered Fitness Journey
        </p>
        <div className="mt-8">
          <div className="animate-spin h-8 w-8 border-4 border-[#4B5FDC] border-t-transparent rounded-full mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default Splash;